import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../../utills/utils";

import Spinner from "../../Modals/SpinnerModal";
import Modal from "../../Modals/CancelModal";
import EditModal from "../../Modals/ProductModal";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  display: flex;
  flex-flow: wrap;
`;

const Shop = styled.div`
  width: 43%;
  height: 180px;
  background: yellow;
  margin: 0 2% 2% 0;
  background: white;
  border: 1px solid #eee;
  padding: 2%;
`;
const ShopTitle = styled.h3`
  font-weight: 500;
  margin: 0;
  padding: 5px 0;
`;
const SecondTitle = styled.p`
  margin: 0;
  padding: 3px 0;
  color: gray;
`;
const Button1 = styled.button`
  width: 45%;
  padding: 10px;
  margin: 5px 5% 0 0;
  font-size: 1em;
  background: #ff5d5d;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
const Button2 = styled.button`
  width: 45%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
  float: left;
`;
const EditButton = styled.button`
  width: 45%;
  padding: 10px;
  margin: 5px 5% 0 0;
  font-size: 1em;
  background: #d0dbdd;
  border: none;
  color: black;
  border-radius: 5px;
  cursor: pointer;
  float: right;
`;
const ShopBio = styled.textarea`
  width: 92.9%;
  padding: 15px 3.3%;
  font-size: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  color: gray; ;
`;
const Input = styled.input`
  width: 92.9%;
  padding: 15px 3.3%;
  font-size: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  color: gray;
`;
const SubTitle = styled.h3`
  padding: 0;
  margin: 15px 0 5px 0;
  font-weight: 600;
  font-size: 1em;
`;
const ShopName2 = styled.h2`
  font-size: 1.3em;
  font-weight: 500;
  margin: 0;
  padding: 3px 0 5px 0;
`;
const CancelTitle = styled.p``;
const ShopItem = (props) => {
  return (
    <Shop>
      <ShopTitle>{props.shop.name}</ShopTitle>
      <SecondTitle>{props.shop.categoryName}</SecondTitle>
      <SecondTitle>{props.shop.phone}</SecondTitle>
      <SecondTitle>{props.shop.email}</SecondTitle>
      <SecondTitle>
        {props.shop.cityName}, {props.shop.thanaName}
      </SecondTitle>
      <Button1
        onClick={() => {
          props.blockModaHandler(props.shop._id);
        }}
      >
        Block
      </Button1>
      <EditButton
        onClick={() => props.editModalHandler(props.index, props.shop)}
      >
        Edit
      </EditButton>

      {/* <Button2 onClick={() => props.cancelModaHandler(props.shop._id)}>
        Cancel
      </Button2> */}
    </Shop>
  );
};

function ShopsRequest() {
  const [shops, setShops] = useState([]);
  const [complete, setComplete] = useState(false);
  const [block, setBlock] = useState(false);
  const [blockId, setBlockId] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [deliveryCharge, setCharge] = useState(25);
  const [selectShop, setSelectShop] = useState({});
  const [shopIndex, setShopIndex] = useState(null);
  const [address, setAddress] = useState("");

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };
  const bioChangeHandler = (e) => {
    setBio(e.target.value);
  };
  const chargeChangeHandler = (e) => {
    setCharge(e.target.value);
  };
  const addressChangeHandler = (e) => {
    setAddress(e.target.value);
  };
  const editShopHandler = (index, shop) => {
    console.log("Hello");
    if (editModal) {
      setEditModal(false);
    } else {
      setEditModal(true);
      setName(shop.name);
      console.log("shop.bio != null", shop.bio != null);
      if (shop.bio && shop.bio != null) {
        setBio(shop.bio);
      }
      setCharge(shop.deliveryCharge);
      setSelectShop(shop);
      setShopIndex(index);
      setAddress(shop.localAddress);
      console.log(shop, index);
    }
  };
  const saveShopHandler = async () => {
    try {
      setSpinner(true);
      await axios
        .post(server, {
          query: `
                mutation{
                              updateShop(
                                name:"${name}", 
                                bio:"${bio}",
                                 shopId:"${selectShop._id}", 
                                 deliveryCharge:${deliveryCharge}
                                 localAddress:"${address}"
                                 ){
                                _id
                                name
                                phone
                                email
                                cityName
                                thanaName
                                categoryName
                                bio
                                deliveryCharge
                                localAddress
                              }
                           }
                         `,
        })
        .then((res) => {
          const allshops = shops;
          allshops[shopIndex] = res.data.data.updateShop;
          setShops(allshops);
          setEditModal(false);
          setSpinner(false);
        });
    } catch (err) {
      setSpinner(false);
      console.log(err);
    }
  };
  const fetchShops = async (args, req) => {
    try {
      const shops = await axios.post(server, {
        query: `
                    query{
                        onBoardShops{
                            _id
                            name
                            phone
                            email
                            cityName
                            thanaName
                            categoryName
                            bio
                            deliveryCharge
                            localAddress
                        }
                    }
                  `,
      });
      console.log("Active shops", shops);
      setShops(shops.data.data.onBoardShops);
      setComplete(true);
    } catch (error) {
      throw error;
    }
  };

  const shopBlockHandler = async (shopId) => {
    try {
      setBlock(false);
      setSpinner(true);
      const shop = await axios.post(server, {
        query: `
                    mutation{
                      bannedShop(shopId:"${shopId}"){
                          _id
                          name
                          phone
                          email
                          location
                        }
                    }
                  `,
      });
      // setShops(shop.data.data.bannedShop);
      const updatedShops = shops.filter((shop) => {
        return shop._id !== shopId;
      });
      setShops(updatedShops);
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };

  const blockModaHandler = (id) => {
    setBlock(true);
    setBlockId(id);
  };
  const blockCloseHandler = () => {
    setBlock(false);
    setBlockId(null);
  };

  useEffect(() => {
    fetchShops();
  }, []);
  return (
    <div>
      <Spinner show={spinner} />

      <Modal show={block} closeModal={blockCloseHandler}>
        <CancelTitle>Are you sure want to block this shop ?</CancelTitle>
        <Button1
          onClick={() => {
            shopBlockHandler(blockId);
          }}
        >
          Yes
        </Button1>
        <Button2 onClick={blockCloseHandler}>No</Button2>
      </Modal>
      <EditModal show={editModal} closeModal={editShopHandler}>
        <ShopName2>Edit Shop</ShopName2>

        <SubTitle>Shop name</SubTitle>

        <Input
          onChange={nameChangeHandler}
          name={name}
          placeholder="Shop name"
          value={name}
        />
        <SubTitle>Shop Bio</SubTitle>

        <ShopBio
          onChange={bioChangeHandler}
          name={bio}
          placeholder="Shop bio"
          value={bio}
        />
        <SubTitle>Delivery charge</SubTitle>

        <Input
          onChange={chargeChangeHandler}
          name={deliveryCharge}
          type="number"
          placeholder="Delivery charge"
          value={deliveryCharge}
        />
        <SubTitle>Local address</SubTitle>

        <Input
          onChange={addressChangeHandler}
          name={address}
          type="text"
          placeholder="address"
          value={address}
        />
        <button
          style={{
            padding: "10px 30px",
            margin: "10px 0",
            color: "white",
            border: "none",
            fontWeight: "bold",
            fontSize: "20px",
            background: "#FF5D5D",
            cursor: "pointer",
          }}
          onClick={() => saveShopHandler()}
        >
          Save
        </button>
      </EditModal>

      {complete ? (
        <Container>
          {shops.map((shop, id) => {
            return (
              <ShopItem
                blockModaHandler={blockModaHandler}
                key={shop._id}
                shop={shop}
                index={id}
                editModalHandler={editShopHandler}
              />
            );
          })}
        </Container>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ShopsRequest;
